import React from 'react';
import { Grid } from '@mui/material';
import { PrimaryButton } from 'library';
import DashboardSection from '../components/DashboardSection';
import { useModalsContext } from 'ModalsContext';

export default function PostJob() {
    const { openJobForm } = useModalsContext();

    const onPostShiftClick = () => {
        openJobForm('Business Dashboard');
    };

    return (
        <DashboardSection
            header="Post a Job"
            description="Get your need posted and you'll be notified as soon as we fill them."
        >
            <Grid container justifyContent="flex-end" style={{ marginTop: 10 }}>
                <PrimaryButton buttonStyle={{ maxWidth: 200 }} onClick={onPostShiftClick}>
                    Post Job
                </PrimaryButton>
            </Grid>
        </DashboardSection>
    );
}
